/** Événements locaux par ville (onglet Développement) : tirage et activité. */
import evenementsData from '../data/dgs/evenements_villes.json';
import { getVille } from './villes';

export const EVENEMENTS_VILLES = evenementsData.evenements;

/** Probabilité quotidienne (~15 % par mois et par ville implantée). */
export const PROBA_EVENEMENT_VILLE_JOUR = 0.005;

export const tirerEvenementVille = (villeId) => {
  const pool = EVENEMENTS_VILLES.filter(e => e.villeId === villeId);
  if (!pool.length) return null;
  const ev = pool[Math.floor(Math.random() * pool.length)];
  return { ...ev, villeNom: getVille(villeId)?.nom || villeId };
};

export const evenementLocalActif = (mag, totalDays) =>
  (mag?.evenementLocal && totalDays < mag.evenementLocal.finJour ? mag.evenementLocal : null);
